import React from "react";
import { Link } from "../../Link";
import { getResizedImageURL } from "../../utils";
import styles from "../styles/ViewMoreListItem.module.scss";

export const ViewMoreListItem = ({ item, fullPost, type }: any) => {
  const itemImageURL = fullPost[0].acf.images[0].url;
  const optimisedImageUrl = itemImageURL
    ? getResizedImageURL(itemImageURL, 600)
    : null;
  const category =
    fullPost[0]._embedded &&
    fullPost[0]._embedded["wp:term"] &&
    fullPost[0]._embedded["wp:term"][0] &&
    fullPost[0]._embedded["wp:term"][0][0].slug;
  const categoryURL = category ? `${category}/` : "";

  return (
    <li>
      <Link
        className={styles.listItem}
        href={`/${type}/${categoryURL}${item.post_name}`}
        title={`View ${item.post_title}`}
      >
        <div
          className={styles.listItemImage}
          style={{ backgroundImage: `url(${optimisedImageUrl})` }}
        />
        <h4 className={styles.listItemTitle}>{item.post_title}</h4>
      </Link>
    </li>
  );
};
